exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.notify-on-top {\n  z-index: 9999 !important;\n  /* 设置一个足够高的z-index值 */\n}\n", ""]);

// exports
